import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

import LanguagePickerQuery, {
    type LocalesForLangPickerQueryResult,
} from "./language-picker-query.tsx";
import LanguagePickerSelect from "./language-picker-select.tsx";

class LanguagePicker extends React.Component<Record<any, any>> {
    render(): React.ReactNode {
        return (
            <LanguagePickerQuery>
                {({
                    loading,
                    error,
                    locales,
                }: LocalesForLangPickerQueryResult) => {
                    return (
                        <LanguagePickerSelect
                            disabled={loading || !!error}
                            locales={locales}
                            defaultSelectedValue={RequestInfo.kaLocale}
                        />
                    );
                }}
            </LanguagePickerQuery>
        );
    }
}

export default LanguagePicker;
